import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'
import { create } from '../store'

type CardOpening = {
  tokenAddress: string;
  createdAt?: string;
  invoiceId?: string;
  metadata?: string;
  mint?: string;
  status?: 'OPENED' | 'IN_PROGRESS' | 'PAID' | 'ERROR' | 'CLOSED' | 'ABORTED';
  title?: string;
  type?: string;
}

interface CardsStore {
  canIssueCard: boolean;
  canIssueCardReason: string[];
  cardOpening: CardOpening;
  selectedCard: string;
  setCanIssueCard: (can: boolean) => void;
  setCanIssueCardReason: (canIssueCardReason: string[]) => void;
  setCardOpening: (card: CardOpening) => void;
  setSelectedCard: (card: string) => void;
}

export const useCardsStore = create<CardsStore>()(
  devtools(
    immer((set) => ({
      selectedCard: null,
      setSelectedCard: (card: string) => set(() => ({ selectedCard: card }), false, 'setSelectedCard'),
      cardOpening: null,
      setCardOpening: (card) => set(() => ({ cardOpening: card }), false, 'setCardOpening'),
      canIssueCard: false,
      setCanIssueCard: (can) => set(() => ({ canIssueCard: can }), false, 'setCanIssueCard'),
      canIssueCardReason: [],
      setCanIssueCardReason: (canIssueCardReason: []) => set(() => ({ canIssueCardReason }), false, 'setCanIssueCardReason'),
    })),
    {
      name: 'useCardsStore',
    },
  ),
)
